import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { confirmForgotPassword } from '../auth/cognito';

export function ResetPasswordPage(): JSX.Element {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [code, setCode] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    if (pw !== pw2) {
      setError('Passwords do not match');
      return;
    }
    setBusy(true);
    try {
      await confirmForgotPassword(email.trim().toLowerCase(), code.trim(), pw);
      setInfo('Password updated. You can now sign in.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to reset password');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-black">
      <div className="w-full max-w-md card">
        <h1 className="text-2xl font-semibold text-white">Reset password</h1>
        <p className="text-sm text-gray-400 mt-1">
          Enter the code we emailed you and choose a new password.
        </p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label className="label" htmlFor="reset-email">Email</label>
            <input
              id="reset-email"
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="reset-code">Reset code</label>
            <input
              id="reset-code"
              className="input"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="reset-password">New password</label>
            <input
              id="reset-password"
              className="input"
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              required
              minLength={10}
            />
          </div>
          <div>
            <label className="label" htmlFor="reset-confirm-password">Confirm new password</label>
            <input
              id="reset-confirm-password"
              className="input"
              type="password"
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              required
              minLength={10}
            />
          </div>
          {error && <div className="text-sm text-red-400">{error}</div>}
          {info && <div className="text-sm text-emerald-400">{info}</div>}
          <button className="btn-primary w-full" type="submit" disabled={busy}>
            {busy ? 'Updating…' : 'Update password'}
          </button>
          <div className="pt-2 border-t border-gray-800 text-sm">
            <Link to="/login" className="text-red-400 hover:text-red-300 hover:underline">
              Back to sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
